import { Component, OnInit,ViewChild } from '@angular/core';
import { GlobalService } from '../global-service.service';
import { MatExpansionPanel} from '@angular/material/expansion';
import { MatTabChangeEvent as MatTabChangeEvent} from '@angular/material/tabs';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../format-datepicker';
import { animate, state, style, transition, trigger} from '@angular/animations';
import * as FileSaver from 'file-saver';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable} from 'rxjs';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';


@Component({
    selector: 'app-pasura',
    templateUrl: './pasura.component.html',
    styleUrls: ['../css/pasura.css'],
    host: { '(document:keyup)': 'onKeyUp($event)' },
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*', minHeight: '50px' })),
            transition('expanded <=> collapsed', animate('400ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    ],
    standalone: false
})

export class PasuraComponent implements OnInit {

  pferdEdit=false;

  
  @ViewChild('panSearchPolice',   {static: false}) private panSearchPolice: MatExpansionPanel;
  @ViewChild('tabGroup', 			 {static: false}) private tabGroup;
   
  formatter = new Intl.NumberFormat('en-US', {
  			style: 'currency',
  			currency: 'CHF',
  			minimumFractionDigits: 2});
  			
  SuchTextPol="";
  
  policen_org;
  policenEditIDX;
  loadRGSpinner=false;
  
  rgTabExpand=false;
  progressSpinner=false;
  
  
  
  findPolicen;
  actTabIdx=0;
  tabPferdExpID =-1;
  anzFP_GJ=-1;
  
  panelPferdeShow=true;

  //displColPferde =[  'Name', 'Sex','Farbe', 'VArt','Nutzung', 'PassChip', 'ID'];
  displColPferde =[  'Name', 'Sex', 'GebDat', 'VArt', 'PassChip', 'ID'];
  displColRechnungen =['Datum', 'Jahr','Titel',  'PraemieBis', 'Status', 'RG-Betrag'];
  displColRechnungen2 =['Datum','Jahr','Titel', 'PraemieBis', 'Status','RG-Betrag','PDF'];
  
  displColFindPolNr=['PolicenNr', 'Name', 'Pferde'];
  
  constructor(public globserv: GlobalService, private dateAdapter: DateAdapter<Date>, private http:HttpClient) 
  {
  		this.dateAdapter.setLocale('de');
  }
  
  ngOnInit() {
  	 
  	  this.globserv.getPasuraAction().subscribe((pasuraAction) => {
      
      if (typeof pasuraAction === 'string')
      {
      
	     	if (pasuraAction=="policeNew")
	      {
	      	this.newPolice();
	      	
	      }else if(pasuraAction=="findPolicen")
	      { 
	      	this.findPolicen=undefined;    
	      	
	      }else if(pasuraAction=="resetPolOrg")
	      {
	      	if (this.globserv.policen!=undefined)
	      	{
	      		this.policen_org= JSON.parse(JSON.stringify(this.globserv.policen));
	      	}
	      	
	      }else if (pasuraAction=="setTabGroupKontakte")
			{
				if (this.tabGroup!=undefined)
				{
					this.tabGroup.selectedIndex=0;
				}	
				
			}else if (pasuraAction=="resetEditPferd")
			{
				this.pferdEdit=false;	
			}
			
		}
    });
    
    this.globserv.startApp();
  }
  
 newPolice()
 {
  		var data={"VN": Number( this.globserv.kontakt.Bexio.nr)};
		this.anzFP_GJ=-1;
		
		var myresult;
		this.globserv.getBackendData("/v1/newPolice",data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {  
    						console.log("myresult newPolice " + JSON.stringify(myresult));
    						
    						if (myresult.Status=="OK")  
    						{
    							this.globserv.setPasuraAction('loadContact;' + myresult.VN);
    							this.tabGroup.selectedIndex=1;
    						}
    					}
		);
  }
		
 
  doSearchPolicen()
  {
  		this.anzFP_GJ=-1;
  		var myresult;
  		//this.kontakte=undefined;
  		//globserv.kontakt=undefined;
  		this.globserv.policen=[{}];
  		
		var data={"Suche":"","TimeStamp" :  new Date().getTime()};
		data.Suche=this.SuchTextPol;
		
		this.globserv.getBackendData("/v1/searchPolicen",data).subscribe(
				result => 
		  		myresult = result,
		  					
		  		err => {
		  			console.log("Error");
		  			console.log(err);
		  			this.findPolicen=undefined;
		  		},
		       () => {
					console.log("myresult " +JSON.stringify(myresult));
		       	this.findPolicen= myresult.Policen;		
		       	this.pferdEdit=false;		       	
		       }
		); 
  }
  
  getPolice(nr)
  {
  		var myresult;
  		this.globserv.policen=[{}];
  		this.anzFP_GJ=-1;
  		
		var data={"Police":nr,"TimeStamp" :  new Date().getTime()};

		this.globserv.getBackendData("/v1/searchPolicen",data).subscribe(
		 
				result => 
		  		myresult = result,
		  					
		  		err => {
		  			console.log("Error");
		  			console.log(err);
		  			this.findPolicen=undefined;
		  		},
		       () => {
					console.log("myresult " +JSON.stringify(myresult));
		       	this.findPolicen= myresult.Policen;		
		       	this.selectPolice(myresult.Policen[0])
		       	this.pferdEdit=false;
		       
		       	//this.pferdOrg=undefined;
		       }
		); 
  }
  
  onKeyUp(ev:KeyboardEvent) 
  {
  	
  	 console.log(ev);
  	 
    if(ev.keyCode==13 )
    {
    	if (this.actTabIdx==1 && this.panSearchPolice.expanded)
    	{
    		if(this.SuchTextPol.length>2)
    		{
    			this.doSearchPolicen();
    		}
    	}
    }
  }
  
  
  
  onTopTabGroupChanged(ev:MatTabChangeEvent)
  {
  		console.log("idx=" + ev.index);
  		this.actTabIdx=ev.index;
  }
  
  
  selectPolice(row)
  {
  		console.log("selectPolice -> " +JSON.stringify(row));
  		this.globserv.setPasuraAction('loadContact;' + row.VN_Nr +";Police");
  		this.panSearchPolice.close();
  		
  }
  
  changedPolicen(idx)
  {
		//console.log("B " + this.policen_org[idx].Zahlweise);	
		//console.log("A " + JSON.stringify(this.globserv.policen[idx]));
  		
  		
  		if (this.globserv.policen==undefined)
  		{
			return false;  		
  		}
  		
  		if (this.policen_org[idx].Zahlweise != this.globserv.policen[idx].Zahlweise)
  		{
			return true;  		
  		}
  		
  		if (this.policen_org[idx].VN_Nr != this.globserv.policen[idx].VN_Nr)
  		{
			return true;  		
  		}
  		
  		if (this.policen_org[idx].PZ_Nr != this.globserv.policen[idx].PZ_Nr)
  		{
			return true;  		
  		}
  		
  		return false;
  }
  
  resetPolicen()
  {
  		this.globserv.policen= JSON.parse(JSON.stringify(this.policen_org));		
  		this.anzFP_GJ=-1;
  }
  
  savePolice(idx)
  {
  		var myresult;
  		
		var data= Object.assign({},this.globserv.policen[idx]);
				 
		
		this.globserv.getBackendData("/v1/savePolice",data).subscribe(
		 
		result => 
		  					myresult = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				this.findPolicen=undefined;
		  					 		  },
		       () => {
		       		console.log("myresult " +JSON.stringify(myresult));
		       		if (myresult.Status=='OK')
		       		{	
		       			this.globserv.policen[idx].edit=false;
		       			this.policen_org= JSON.parse(JSON.stringify(this.globserv.policen));
		       		}
		       }
		);   
  }
  
  restoreVersicherungPferd(polIDX, pferdID)
  {
  	
  		var pferdIDX= this.globserv.policen[polIDX].Pferde.findIndex(pferd => pferd.ID === pferdID);
  		
  		var myresult;
  		var data= {"PferdID": pferdID};
  		
  		this.panelPferdeShow=false;
  		this.progressSpinner=true;
  		
  		console.log(polIDX);
  		console.log(pferdID);
  		console.log(pferdIDX);
				 
		//this.globserv.policen[polIDX].Pferde[pferdIDX].V_Ende="";
  		//this.globserv.policen[polIDX].Pferde[pferdIDX].Abgegangen=false; 	
  		
		
		this.globserv.getBackendData("/v1/restoreVersicherungPferd",data).subscribe(
		 
				result => 
		  		myresult = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				this.findPolicen=undefined;
		  					 		  },
		       () => {
		       		console.log("myresult " +JSON.stringify(myresult));
		       		
		       		
						if (myresult.Status=='OK')
		       		{
		       			console.log(myresult.Status);
		       			if (myresult.Pferd!=undefined)
		       			{
		       				console.log(myresult.Pferd!=undefined);
		       				
		       				//    
		       				//console.log("Policen " +JSON.stringify(this.globserv.policen));
		       				
		       				//this.globserv.policen[polIDX].Pferde[pferdIDX].V_Ende=myresult.Pferd.V_Ende;
  								//this.globserv.policen[polIDX].Pferde[pferdIDX].Abgegangen=myresult.Pferd.Abgegangen; 
  								//this.globserv.policen[polIDX].Pferde[pferdIDX] = Object.assign({},myresult.Pferd);
  								this.globserv.policen[polIDX].Pferde[pferdIDX] = myresult.Pferd;
  								
  								//this.globserv.cdr.detectChanges();
  								//window.location.reload();
  								//this.globserv.policen[polIDX].Pferde[pferdIDX].V_Ende="";
  								//this.globserv.policen[polIDX].Pferde[pferdIDX].Abgegangen=false; 		
		       					
		       			}
		       		}
		       		this.panelPferdeShow=true;
		       		this.progressSpinner=false;
		       	}
		);  
		 
  }
  
 
  
  showPolicen()
  {
  				
		if(this.globserv.policen==undefined)
		{
				return true;	
		}
		
		return this.globserv.policen.length <=0;
  }
  
  toggelEditPol(i)
  {
  		console.log("toggelEditPol " + i);
  		this.globserv.policen[i].edit = (!this.globserv.policen[i].edit);
  }
  
  editPferd(iPol,pferdID)
  {
  		this.globserv.setPasuraAction('setEditPferd;'+ iPol +";" + pferdID);  	
  		this.pferdEdit=true;
  }
  
  getZahlweiseText(zw)
  {
  		switch(zw)
  		{
			case 1:
				return "jährlich";
				break;
				
				
			case 2:
				return "halbjährlich";
				break
				
			case 4:
				return "vierteljährlich";
				
			case 12:
				return "monatlich";
				
  		}
  		return "jährlich";
  }
  
  getDatumCH(date)
  {
  		date= this.getJsonDate(date); 		
  		
		if (date.length==10)
		{
			return(date.substr(8) +"." +date.substr(5,2)+"." +date.substr(0,4));		  
		}
		return date;
  }
  
  
  isDate(d)
  {
		return (d instanceof Date);  
  }
  
  getJsonDate(date)
  {
  	
  		var d= new Date(date);
		var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

    	if (month.length < 2) 
        month = '0' + month;
    	if (day.length < 2) 
        day = '0' + day;

    	return [year, month, day].join('-');
  }
  
 
  
  toggleOption(opt, optArray)
  {
  		let idx = optArray.indexOf(opt.OptionID);
  		
  		if (idx>=0)
  		{
  			optArray.splice(idx, 1);	
  		}else{
			optArray.push(opt.OptionID);  		
  		}
  }
  
  isSelOption(opt, optArray)
  {
  		return optArray.indexOf(opt.OptionID) >-1;
  }
  
  getSubTarifIdx(tarif)
  {
  		var idx= this.globserv.tarifPferd.SubTarife.map(e => e.TarifID).indexOf(tarif);
  		return idx;
  }
  
  getNumber(s)
  {
		return Number(s);  
  }
  
  	
  getPolicePDF(pferdID) 
  {

		
		var data= Object.assign({},this.globserv.policen[0]);
		
		//console.log(JSON.stringify(data));
		   		
  		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');

		 
		this.http.post("/api/v1/getPolicenPDF/?pferdID="+pferdID, data, {responseType: 'blob' 
		 		}).subscribe((response: Blob) => {
            
               FileSaver.saveAs(response, "Police_" +data.PolicenNr+ ".pdf");
            });
  }
  
    
  makeErstRechnung(pferd)
  {
		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');
		 
		this.progressSpinner=true;
		var data= Object.assign({},this.globserv.policen[0]);
		
		this.http.post("/api/v1/makeErstRechnung/?pferdID="+pferd.ID, data, { headers: headers, responseType: 'blob' })
            .subscribe((response: Blob) => {
            	this.progressSpinner=false;
            	this.reloadPolice();
               FileSaver.saveAs(response, "Erstrechnung.pdf");
            });
  }
    
  remakeFPRechnung(polData, polIDX)
  {
  		//console.log( JSON.stringify(pferd));
  		
  		this.loadRGSpinner=true;
  		this.progressSpinner=true;
  	
  		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');
		 
		var data= Object.assign({},polData);
		data.RGJahr=this.globserv.RGJahr;
		
		
		this.http.post("/api/v1/remakeFPRechnung", data, { headers: headers, responseType: 'blob' })
            .subscribe((response: Blob) => {
            	this.loadRechnungen(polIDX);
            	this.progressSpinner=false;
               FileSaver.saveAs(response, "FP_" + polData.PolicenNr+ "_" + this.globserv.RGJahr + ".pdf");
      });
  }
  
  
  openPolice(nr)
  {
		console.log("openPolice " + nr); 
		this.getPolice(nr);
		this.tabGroup.selectedIndex=1;
  }
  
  
 
	
	
	getRechnungPDF(rgID) 
   {
		
		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');

		  
		this.http.post("/api/v1/getRechnungPDF/?rgID=" +rgID +"&logo="+ this.globserv.Settings.PrintLogo,{}, {responseType: 'blob' 
		 		}).subscribe((response: Blob) => {
            
               FileSaver.saveAs(response, "Rechnung_"+rgID+".pdf");
            });
    
  }
  
	doRGReNew(rg)
	{
		
		var myresult;
  		
  		var myresult;
		var data= Object.assign({},this.globserv.policen[0]);
		
		console.log("police=" +JSON.stringify(data));


		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');
		 
	
		
		this.http.post("/api/v1/editRechnung/?RechnungID="+rg.BexioID, data,{ headers: headers, responseType: 'blob' })
            .subscribe((response: Blob) => {
               FileSaver.saveAs(response, "Rechnung.pdf");
               this.reloadPolice();
      });
	}
	
	
	doRGReNewFP(rg)
	{
		
		var myresult;
  		
  		var myresult;
		var data= Object.assign({},this.globserv.policen[0]);
		
		console.log("police=" +JSON.stringify(data));


		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');
		
		this.http.post("/api/v1/editRechnung/?RechnungID="+rg.BexioID, data,{ headers: headers, responseType: 'blob' })
            .subscribe((response: Blob) => {
               FileSaver.saveAs(response, "Rechnung.pdf");
               this.reloadPolice();
      });
	}
	
	
	/*
	reloadPolice()
	{
		this.globserv.setPasuraAction('loadContact;' + this.globserv.policen[0].VN_Nr) +";reload";
	}
	*/
	
	
	  
	  
  reloadPolice()
  {
  	
  		var myresult;
  		var data={};
  		this.globserv.setPasuraAction("resetSchadenfall");
  		
  		 
  		var resultData;
  		this.globserv.getBackendData("/v1/getContactPolicen/?nr="+this.globserv.policen[0].VN_Nr +"&TimeStamp=" +new Date().getTime(),data).subscribe(
			result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Kontakt (" + this.globserv.policen[0].VN_Nr + ") konnte nicht geladen werden!"}});	  					 				
  					 		  },
		       () => {
		       
		       
		        	
	       		if (resultData.Policen!=undefined)
	       		{
	       			this.globserv.policen = resultData.Policen;
	       										
	       		}else{
										       		
						this.globserv.policen= [{}];
	       			this.globserv.setPasuraAction("resetPolOrg");
	       		}
	       	}
		); 
	
  }
	
	doRGEntwurf(rg)
	{
		
		var myresult;
		var data={};
		
		this.globserv.getBackendData("/v1/revertIssueRG?RechnungID=" + rg.BexioID, data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {       		
    						if(myresult.success==true)
    						{
    							rg.Status="Entwurf";
    							rg.StatusID=7;
    						}
    					}
		);
	}
	
	doRGDelete(rg, polIDX)
	{
		var resultData;
		var data={};
		this.loadRGSpinner=true;
		
		this.globserv.getBackendData("/v1/deleteRG?RechnungID=" + rg.RechnungID, data).subscribe(
	 
				result => 
  					resultData = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 				this.loadRGSpinner=false;
  					 		  },
    			
    			() => {       		
    				
    				this.loadRGSpinner=false;
    				
					if (resultData.anzFP_GJ!=undefined)
	       		{
		        		this.anzFP_GJ= resultData.anzFP_GJ;
		        		
		        	}else{
		        		
		        		this.anzFP_GJ=0;
		        	}    				
    				
	       		if (resultData.Rechnungen!=undefined)
	       		{
	       			this.globserv.policen[polIDX].Rechnungen= resultData.Rechnungen;
	       			this.rgTabExpand=true;
	       											
	       		}else{
										       		
						this.globserv.policen[polIDX].Rechnungen= [{}];
						this.rgTabExpand=false;	
	       		}
    					}
		);
	}
	
	
	loadRechnungen(polIDX)
   {
  		var myresult;
  		var data={};
  		
  		this.loadRGSpinner=true;
  		
  		var nr = this.globserv.policen[polIDX].PolicenNr;
  		console.log("loadRechnungen für Police " + nr + " (" + polIDX + ")");
  		 
  		var resultData;
  		this.globserv.getBackendData("/v1/getRechnungen/?nr="+nr +"&TimeStamp=" +new Date().getTime(),data).subscribe(
			result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Rechungen für Police (" + nr + ") konnte nicht geladen werden!"}});
  					 				this.loadRGSpinner=false;	  					 				
  					 		  },
		       () => {
		       
		        	this.loadRGSpinner=false;

	       		if (resultData.anzFP_GJ!=undefined)
	       		{
		        		this.anzFP_GJ= resultData.anzFP_GJ;
		        		
		        	}else{
		        		
		        		this.anzFP_GJ=0;
		        	}
		        	
	       		if (resultData.Rechnungen!=undefined)
	       		{
	       			console.log( JSON.stringify(resultData));
	       			this.globserv.policen[polIDX].Rechnungen= resultData.Rechnungen;
	       			this.rgTabExpand=true;
	       											
	       		}else{
										       		
						this.globserv.policen[polIDX].Rechnungen= [{}];
						this.rgTabExpand=false;	
	       		}
		       }
		); 
  }
  
  calcOK()
  {
		return true;  
  }
  
  getDatasourcePferde(police)
  {
  		//return police.PferdeInaktiv;
  		return police.Pferde
  }
  
  getTitelSchadenfaelle()
  {
  		var titel= "Schadenfälle";
  		if (this.globserv.anzSchadenfaelle>0)
  		{
  			titel +=" ("+this.globserv.anzSchadenfaelle + ")";
  		}
  		
  		return titel;
	}
	
	getPerdListeItem(element,column)
	{
		if (column=='GebDat')
		{
			return 	this.getDatumCH(element[column]);
		}	
		return element[column];
	}
}
